import EmptyPage           from '../components/empty_page';
import RedirectToInboxPage from './redirect_to_inbox_page';
import renderPage          from '../components/render_page';
import Tab                 from '../contacts_page/tab';

export default {
  path:      '/:businessID/customers',
  component: renderPage(EmptyPage),
  name:      'CustomerList',
  on:        {
    pageBeforeIn(_, { route, router }) {
      const { params }     = route;
      const { businessID } = params;

      router.navigate(`/${businessID}/inbox`, { reloadAll: true });
    }
  },
  routes: [
    {
      path:         ':contactID',
      component:    renderPage(RedirectToInboxPage),
      name:         'Customer',
      tabComponent: {
        component: Tab,
        name:      'contacts'
      },
      routes: [
        {
          path:         'info',
          component:    renderPage(RedirectToInboxPage),
          name:         'Customer',
          tabComponent: {
            component: Tab,
            name:      'contacts'
          }
        },
        {
          path:      'invoice',
          component: renderPage(EmptyPage),
          name:      'Invoice',
          on:        {
            pageBeforeIn(_, { route, router }) {
              const { params }     = route;
              const { businessID } = params;
              const { customerID } = params;

              router.navigate(`/${businessID}/contacts/${customerID}/invoice`, { reloadAll: true });
            }
          }

        }]
    }
  ]
};
